import React from 'react';
import { Badge } from 'react-bootstrap';
import { getStandardObjectStatusLabel, normalizeStandardStatus, STANDARD_STATUS } from '../../utils/standardObjectPublishing';
import { useProductBuilderMode } from '../../utils/productBuilderMode';

const VARIANT_BY_STATUS = {
  [STANDARD_STATUS.DRAFT]: 'warning',
  [STANDARD_STATUS.PUBLISHED]: 'success',
  [STANDARD_STATUS.ARCHIVED]: 'secondary',
};

/**
 * Shows Draft / Published / Archived Standard Object label for standard objects.
 * Published and archived labels are visible only in product builder mode.
 */
const StandardObjectStatusBadge = ({ object, className = '' }) => {
  const productBuilderMode = useProductBuilderMode();
  const label = getStandardObjectStatusLabel(object, productBuilderMode);
  if (!label) return null;

  const status = normalizeStandardStatus(object?.standard_status);
  const variant = VARIANT_BY_STATUS[status] || 'light';

  return (
    <Badge bg={variant} className={className} title={label}>
      {label}
    </Badge>
  );
};

export default StandardObjectStatusBadge;
